import React, { useState, useEffect } from "react";
import "../Styles/ReviewAgent.css";

import { useLocation, useNavigate } from "react-router-dom";
import { IoChevronBackOutline } from "react-icons/io5";
import {
  create_agent_review_from_profile,
  get_agent_review_by_profile,
} from "../api/serverWrapper";
function ReviewAgent() {
  const navigate = useNavigate();

  const [existingReview, setExistingReview] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadExistingReview();
  }, []);

  const loadExistingReview = async () => {
    try {
      const response = await get_agent_review_by_profile(
        agentData?.UserId,

        UserData?.ProfileId,
      );

      if (response?.code === 200 && response?.data) {
        setExistingReview(response.data);

        setRating(response.data.Rating);

        setReview(response.data.ReviewComment || "");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const location = useLocation();

  const { agentData, UserData } = location.state || {};

  const [rating, setRating] = useState(4);

  const [review, setReview] = useState("");

  const [reviewPosted, setReviewPosted] = useState(false);

  const handlePostReview = async () => {
    if (loading) return;
    try {
      if (!review.trim()) {
        alert("Please write review");
        return;
      }

      setLoading(true);

      const payload = {
        UserId: agentData?.UserId,

        ProfileId: UserData?.ProfileId,

        Rating: rating,

        ReviewComment: review,
      };

      console.log("Review Payload", payload);

      const response = await create_agent_review_from_profile(payload);

      console.log("Review Response", response);

      if (response?.code === 200 || response?.success) {
        setReviewPosted(true);

        setTimeout(() => {
          navigate(-1);
        }, 1500);
      } else {
        alert(response?.message || "Failed to post review");
      }
    } catch (error) {
      console.log(error);

      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="post-review-page">
      {/* NAVBAR */}

      <div className="client-setup-header-main">
        <div className="client-setup-header-left">
          <IoChevronBackOutline
            className="client-setup-back-icon"
            onClick={() => navigate(-1)}
          />

          <img
            src={require("../assests/images/nav_bar_logo.png")}
            alt="Wedluk Logo"
            className="client-setup-logo"
          />
        </div>

        <div className="client-setup-header-right">
          <span>Review</span>
        </div>
      </div>

      {/* CARD */}

      <div className="post-review-card">
        {/* TITLE */}

        <div className="post-review-title-section">
          <h2>Review Agent/Agency</h2>

          <div className="post-review-title-line"></div>
        </div>

        {/* PROFILE */}

        <div className="post-review-profile-card">
          <div className="post-review-profile-left">
            <img
              src={
                agentData?.User?.ProfilePhotoUrl ||
                "https://randomuser.me/api/portraits/men/32.jpg"
              }
              alt=""
            />

            <span>
              {agentData?.User?.FirstName} | {agentData?.BusinessName}
            </span>
          </div>

          {/* STARS */}

          <div className="post-review-stars-row">
            {[1, 2, 3, 4, 5].map((item) => (
              <span
                key={item}
                onClick={() => setRating(item)}
                className={
                  item <= rating
                    ? "post-review-active-star"
                    : "post-review-inactive-star"
                }
              >
                ★
              </span>
            ))}
          </div>
        </div>

        {/* TEXTAREA */}

        <div className="post-review-input-wrapper">
          <textarea
            placeholder="Write review"
            maxLength={250}
            value={review}
            onChange={(e) => setReview(e.target.value)}
          />

          <div className="post-review-arrow">❯</div>

          <div className="post-review-count">{review.length}/250</div>
        </div>

        {/* FOOTER */}

        <div className="post-review-footer">
          <button  onClick={handlePostReview} disabled={loading} className={loading ? "loading-btn" : ""}>
            {loading
              ? "Posting..."
              : existingReview
                ? "Update Review"
                : "Post Review"}
          </button>
        </div>
      </div>

      {/* SUCCESS */}

      {reviewPosted && (
        <div className="post-review-success-popup">Review Posted</div>
      )}
    </div>
  );
}

export default ReviewAgent;
